// 네이버 검색광고 키워드 성과 측정용.
// 여기서는 window.dataLayer 에 값만 넣는다. GTM 이 그 값을 읽어 모든 GA4 이벤트에 붙여 보낸다.
// (GTM 은 window.load 뒤에 늦게 켜지지만, dataLayer 에 쌓인 값은 켜질 때 순서대로 처리된다)

// 네이버 광고 클릭 시 주소에 붙는 꼬리표(URL 파라미터) → GA4 매개변수 이름
const NAVER_PARAMS = {
  n_keyword: "naver_keyword",
  n_query: "naver_query",
  n_rank: "naver_rank",
  n_media: "naver_media",
  n_keyword_id: "naver_keyword_id",
};
const STORE_KEY = "naver_ad_params"; // sessionStorage 키 (탭을 닫으면 사라진다)

// 앱 시작 시 1번 호출: 광고 꼬리표를 메모하고 GTM 에 알려준다.
// 꼬리표는 첫 화면 주소에만 있어서, 다른 페이지로 가기 전에 메모해 둬야 한다.
export const captureNaverAdParams = () => {
  try {
    const query = new URLSearchParams(window.location.search);
    if (query.get("n_keyword")) {
      // 새 광고 클릭 → 이전 값을 통째로 교체 (이전 클릭 값과 섞이지 않게)
      const fresh = {};
      Object.entries(NAVER_PARAMS).forEach(([urlKey, gaKey]) => {
        const value = query.get(urlKey);
        if (value) fresh[gaKey] = value.slice(0, 100); // GA4 값 길이 제한 100자
      });
      sessionStorage.setItem(STORE_KEY, JSON.stringify(fresh));
    }
    const saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || "null");
    if (saved) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(saved);
    }
  } catch (e) {
    // 저장소가 막힌 브라우저에서는 조용히 넘어간다
  }
};
